import { openHomepage as openHomepageUtil } from "@utils/commonUtils";

export const openHomepage = (args: any) => {
  const { link } = args;
  openHomepageUtil({ link });
};

